import { render } from "./PatientTimeline.vue?vue&type=template&id=66b5774d&scoped=true"
import script from "./PatientTimeline.vue?vue&type=script&lang=js"
export * from "./PatientTimeline.vue?vue&type=script&lang=js"

import "./PatientTimeline.vue?vue&type=style&index=0&id=66b5774d&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66b5774d"]])

export default __exports__